module.exports = __webpack_public_path__ + "media/conmex/temas-fcd81039.png";